import { useCallback } from 'react';

import { BackendRoute } from '../config/index';
import { ApiService } from '../services/index';

export type UploadFileToS3Handlers = {
  setAbort: () => void;
  setProgress: (progress: number, abort: () => void) => void;
  setSuccess: (link: string, abort: () => void) => void;
  setUploading: (abort: () => void) => void;
};

export const useUploadFileToS3 = () => {
  const uploadFile = useCallback(async (file: File, handlers: UploadFileToS3Handlers) => {
    const { callback, abort } = ApiService.uploadFile<string>();

    handlers.setUploading(abort);

    const link = await callback(
      { endpoint: BackendRoute.SHARE_CLASSES, routePath: ['file'] },
      ['file', file],
      {
        onUploadProgress: (n: number) => handlers.setProgress(n, abort),
        onAboard: handlers.setAbort,
      },
    );

    if (link) handlers.setSuccess(link, abort);
    return link;
  }, []);

  return { uploadFile };
};
